import { getFolderChangeDigestAction } from 'owa-mail-focused-inbox-rollup-store';
import { getSelectedTableView, getFocusedFilterForTable } from 'owa-mail-list-store';
import { action } from 'satcheljs/lib/legacy';
/**
 * Get rollup data on add/update row notification
 * @param notificationTable for which row notification is received
 */
export default action('updateRollupOnAddOrUpdateRowNotification')(function updateRollupOnAddOrUpdateRowNotification(notificationTable) {
    var selectedTableView = getSelectedTableView();
    if (selectedTableView == null) {
        return;
    }
    var notificationFocusedViewFilter = getFocusedFilterForTable(notificationTable);
    var selectedTableFocusedViewFilter = getFocusedFilterForTable(selectedTableView);
    // Fetch new data for rollup on add/update row notification for Focused and current view is Other or
    // on new mail notification for Other and current filter is Focused
    if ((notificationFocusedViewFilter == 0 /* Focused */ &&
        selectedTableFocusedViewFilter == 1 /* Other */) ||
        (notificationFocusedViewFilter == 1 /* Other */ &&
            selectedTableFocusedViewFilter == 0 /* Focused */)) {
        getFolderChangeDigestAction(notificationTable);
    }
});
//# sourceMappingURL=updateRollupOnAddOrUpdateRowNotification.js.map